export default {
    computed: {
        allQueues () {
            return this.$store.state.queues.all
        },
        queueWithActiveCalls () {
            return this.$store.getters['queues/queueWithActiveCalls'] || []
        },
        allQueueCalls () {
            return this.$store.getters['queues/allQueueCalls'] || []
        }
    }
}
